<template>
  <div class="c--shared_station statin-page">
    <div
      :class="[
        'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3',
        'tw-gap-0 md:tw-gap-6',
        'tw-shadow md:tw-shadow-none',
        'tw-rounded md:tw-rounded-none',
        'tw-overflow-hidden md:tw-overflow-visible',
      ]"
    >
      <template v-if="stationLists">
        <template v-for="(item, index) in stationLists.first">
          <template v-if="item.isUserName">
            <div :key="`station-list-first-route-${index}`" class="station-list-item relative md:tw-hidden">
              <UserBox
                :user-name="item.key"
                :user-rank-title="getUserRankTitle(item.badgeData)"
                :user-rank-image-url="getUserRankImageURL(item.badgeData)"
              />
            </div>
          </template>
          <template v-else>
            <template v-if="item.emit && !item.route">
              <a
                :key="`station-list-first-route-${index}`"
                class="md:tw-shadow"
                :class="itemClass(item)"
                @click.prevent="onEmit(item.emit)"
              >
                <span>{{ itemKey(item) }}</span>
                <span :class="iconWrapperClass()">
                  <a-icon
                    type="image"
                    loader="data"
                    name="icon-package-arrow-general-light"
                    width="22"
                    height="22"
                    :class="{
                      'rtl-transform-rotate-y': $dir() === 'rtl',
                    }"
                  />
                </span>
              </a>
            </template>
            <template v-else-if="item.route && item.isExternalRoute">
              <a
                :key="`station-list-first-isExternalRoute-${index}`"
                class="md:tw-shadow"
                :class="itemClass(item)"
                target="_blank"
                :href="item.route"
              >
                <span>{{ itemKey(item) }}</span>
                <span :class="iconWrapperClass()">
                  <a-icon
                    type="image"
                    loader="data"
                    name="icon-package-arrow-general-light"
                    width="22"
                    height="22"
                    :class="{
                      'rtl-transform-rotate-y': $dir() === 'rtl',
                    }"
                  />
                </span>
              </a>
            </template>
            <template v-else>
              <nuxt-link
                :key="`station-list-first-else-${index}`"
                class="md:tw-shadow"
                :class="itemClass(item)"
                :to="localePath(item.route)"
              >
                <span>{{ itemKey(item) }}</span>
                <span :class="iconWrapperClass()" v-if="!item.isUserName && !item.isUserLogin">
                  <a-icon
                    type="image"
                    loader="data"
                    name="icon-package-arrow-general-light"
                    width="22"
                    height="22"
                    :class="{
                      'rtl-transform-rotate-y': $dir() === 'rtl',
                    }"
                  />
                </span>
                <span :class="iconWrapperClass()" v-if="item.isUserLogin">
                  <a-icon
                    type="image"
                    loader="data"
                    :name="`User-Active-${$store.getters.get_app_theme_mode}`"
                    width="44"
                    height="44"
                  />
                </span>
              </nuxt-link>
            </template>
          </template>
        </template>

        <template v-for="(item, index) in stationLists.second">
          <template v-if="item.emit && !item.route">
            <a
              :key="`station-list-second-${index}`"
              class="md:tw-shadow"
              :class="itemClass(item, true)"
              @click.prevent="onEmit(item.emit)"
            >
              <span>{{ itemKey(item) }}</span>
              <span :class="iconWrapperClass()">
                <a-icon
                  type="image"
                  loader="data"
                  name="icon-package-arrow-general-light"
                  width="22"
                  height="22"
                  :class="{
                    'rtl-transform-rotate-y': $dir() === 'rtl',
                  }"
                />
              </span>
            </a>
          </template>
          <template v-else-if="item.route && item.isExternalRoute">
            <a
              :key="`station-list-second-isExternalRoute-${index}`"
              class="md:tw-shadow"
              :class="itemClass(item, true)"
              target="_blank"
              :href="item.route"
            >
              <span>{{ itemKey(item) }}</span>
              <span :class="iconWrapperClass()">
                <a-icon
                  type="image"
                  loader="data"
                  name="icon-package-arrow-general-light"
                  width="22"
                  height="22"
                  :class="{
                    'rtl-transform-rotate-y': $dir() === 'rtl',
                  }"
                />
              </span>
            </a>
          </template>
          <template v-else>
            <nuxt-link
              :key="`station-list-second-else-${index}`"
              class="md:tw-shadow"
              :class="itemClass(item, true)"
              :to="localePath(item.route)"
            >
              <span>{{ itemKey(item) }}</span>
              <span :class="iconWrapperClass()">
                <a-icon
                  type="image"
                  loader="data"
                  name="icon-package-arrow-general-light"
                  width="22"
                  height="22"
                  :class="{
                    'rtl-transform-rotate-y': $dir() === 'rtl',
                  }"
                />
              </span>
            </nuxt-link>
          </template>
        </template>
      </template>
    </div>

    <div
      class="d-grid grid-cols-1 gap-0 mt-20 box-rounded shadowed overflow-hidden md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-6 md:tw-shadowed-none md:tw-hidden"
      v-if="stationLists.second && stationLists.second.length > 0"
    >
      <template v-for="(item, index) in stationLists.second">
        <template v-if="item.emit && !item.route">
          <a :key="`station-list-other-second-${index}`" :class="itemClass(item)" @click.prevent="onEmit(item.emit)">
            <span>{{ itemKey(item) }}</span>
            <span :class="iconWrapperClass()">
              <a-icon
                type="image"
                loader="data"
                name="icon-package-arrow-general-light"
                width="22"
                height="22"
                :class="{
                  'rtl-transform-rotate-y': $dir() === 'rtl',
                }"
              />
            </span>
          </a>
        </template>

        <template v-else-if="item.route && item.isExternalRoute">
          <a
            :key="`station-list-other-second-isExternalRoute-${index}`"
            :class="itemClass(item)"
            target="_blank"
            :href="item.route"
          >
            <span>{{ itemKey(item) }}</span>
            <span :class="iconWrapperClass()">
              <a-icon
                type="image"
                loader="data"
                name="icon-package-arrow-general-light"
                width="22"
                height="22"
                :class="{
                  'rtl-transform-rotate-y': $dir() === 'rtl',
                }"
              />
            </span>
          </a>
        </template>
        <template v-else>
          <nuxt-link
            :key="`station-list-other-second-else-${index}`"
            :class="itemClass(item)"
            :to="localePath(item.route)"
          >
            <span>{{ itemKey(item) }}</span>
            <span :class="iconWrapperClass()">
              <a-icon
                type="image"
                loader="data"
                name="icon-package-arrow-general-light"
                width="22"
                height="22"
                :class="{
                  'rtl-transform-rotate-y': $dir() === 'rtl',
                }"
              />
            </span>
          </nuxt-link>
        </template>
      </template>
    </div>
    <div
      class="d-grid grid-cols-1 gap-0 mt-20 box-rounded shadowed overflow-hidden md:tw-grid-cols-2 lg:tw-grid-cols-3 md:tw-gap-6 md:tw-shadowed-none md:tw-hidden"
      v-if="logOutItem"
    >
      <a :class="itemClass(logOutItem)" @click.prevent="onEmit(logOutItem.emit)">
        <span>{{ $t(logOutItem.key) }}</span>
        <span :class="iconWrapperClass()">
          <a-icon
            type="image"
            loader="data"
            name="ic_logout"
            width="22"
            height="22"
            :class="{
              'rtl-transform-rotate-y': $dir() === 'rtl',
            }"
          />
        </span>
      </a>
    </div>
  </div>
</template>

<script>
  import UserBox from '~/components/shared/user-box.vue'

  export default {
    components: {
      UserBox,
    },

    props: {
      list: {
        type: Array,
        required: false,
        default: [],
      },
    },

    computed: {
      stationLists() {
        if (this.list.length === 0) return null
        const groupFirst = this.list
          .filter((v) => v.group === 'first')
          .filter((v) => !v.isLogOut)
          .map((v, i, l) => ({
            ...v,
            ...(i === 0 && { isFirst: true }),
            ...(i === l.length - 1 && { isLast: true }),
          }))
        const groupSecond = this.list
          .filter((v) => v.group === 'second')
          .map((v, i, l) => ({
            ...v,
            ...(i === 0 && { isFirst: true }),
            ...(i === l.length - 1 && { isLast: true }),
          }))

        return { first: groupFirst, second: groupSecond }
      },

      logOutItem() {
        if (this.list.length === 0) return null

        return this.list.find((v) => v.isLogOut)
      },

      isSplit() {
        return this.$device.isMobile
      },
    },

    methods: {
      itemClass(item, isSecond) {
        return [
          'station-list-item typo-checkbox text-decoration-none cursor-pointer md:after:!tw-h-0',
          'justify-content-start align-items-center relative',
          'bg-white px-20',
          {
            'typo-sm-h5 md:box-rounded md:tw-shadowed md:h-box-75 md:p-20': true,
          },
          {
            'tw-hidden md:tw-flex': isSecond,
          },
          {
            'tw-flex md:tw-hidden': item.isHideDesktop,
          },
          {
            'display-flex': !item.isHideDesktop && !isSecond,
          },
          {
            'typo-h3 pt-35 pb-30': item.isUserName,
          },
          {
            'typo-h5 py-20': item.isUserLogin,
          },
          {
            'py-15': !item.isUserName && !item.isUserLogin,
          },

          {
            'color-text-red': item.isLogOut,
          },
          {
            'color-text-primary': !item.isLogOut,
          },
        ]
      },

      itemKey(item) {
        return this.$t(item.key, item.keyParameters)
      },

      iconWrapperClass() {
        return {
          'ml-auto mt-1': this.$dir() === 'ltr',
          'mr-auto mt-1': this.$dir() === 'rtl',
        }
      },

      onEmit(name) {
        this.$emit(name)
      },

      getUserRankTitle(badgeData) {
        return badgeData?.title || null
      },

      getUserRankImageURL(badgeData) {
        return badgeData?.image?.url || null
      },
    },
  }
</script>

<style lang="scss" scoped>
  .station {
    &-list {
      &-item {
        &.is-second {
          display: none;

          @media screen and (min-width: 576px) {
            display: flex;
          }
        }

        &.is-hide-desktop {
          @media screen and (min-width: 576px) {
            display: none;
          }
        }

        &::after {
          content: '';
          position: absolute;
          left: 20px;
          bottom: -1px;
          width: calc(100% - 20px);
          height: 1px;
          background-color: #eeeeee;
          z-index: 2;
        }
      }
    }
  }
</style>
